import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'

import type { PromptTemplateDrawerFormSchemaType } from './prompt-template-drawer-form.schema'

const NAME_MAX_LENGTH = 200

interface PromptTemplateNameFieldProps {
  form: UseFormReturn<PromptTemplateDrawerFormSchemaType>
  isDisabled?: boolean
}

export const PromptTemplateNameField = ({
  form,
  isDisabled = false,
}: PromptTemplateNameFieldProps): ReactNode => (
  <FormField
    control={form.control}
    name="name"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Name</FormLabel>
        <FormControl>
          <Input
            placeholder="Enter template name"
            className="prompt-template-name-input"
            maxLength={NAME_MAX_LENGTH}
            disabled={isDisabled}
            {...field}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
)

PromptTemplateNameField.displayName = 'PromptTemplateNameField'
